import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const InfoFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 2.41C6.7 2.41 2.41 6.7 2.41 12S6.7 21.59 12 21.59s9.59-4.29 9.59-9.59-4.3-9.59-9.59-9.59Zm-.94 5.07c.25-.26.56-.38.94-.38a1.297 1.297 0 0 1 1.33 1.33c0 .38-.13.69-.38.95s-.57.38-.95.38-.69-.13-.94-.38c-.25-.26-.38-.57-.38-.95s.13-.69.38-.95Zm1.99 9.08c-.28.23-.63.35-1.05.35-.42 0-.78-.12-1.06-.36-.27-.24-.41-.56-.41-.97 0-.09 0-.16.01-.22l.73-4.25c.03-.24.11-.42.24-.55.13-.13.29-.19.49-.19s.35.06.49.19c.13.13.22.31.25.55l.71 4.26c0 .05.01.13.01.22 0 .41-.14.73-.42.97h.01Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default InfoFilled
